import { companyManagementUrl } from "../config";

const DEFAULT_LOGO_PATH = "/assets/M.svg";
const COMPANY_LOGO_PATH_PREFIX = "/assets/companylogos/";

const getCompanyGatewayOrigin = () => {
  try {
    return new URL(companyManagementUrl.upload_logo_uri).origin;
  } catch (error) {
    return "";
  }
};

const normalizeRelativePath = (pathValue) => {
  let cleanedPath = pathValue.replace(/\\/g, "/");
  cleanedPath = cleanedPath.replace(/^(\.\.\/)+/, "/");
  cleanedPath = cleanedPath.replace(/^(\.\/)+/, "/");

  if (!cleanedPath.startsWith("/")) {
    cleanedPath = `/${cleanedPath}`;
  }

  return cleanedPath;
};

export const normalizeLogoPath = (logoPath) => {
  if (!logoPath) {
    return DEFAULT_LOGO_PATH;
  }

  const rawPath = String(logoPath).trim();
  if (!rawPath || rawPath === "null" || rawPath === "undefined") {
    return DEFAULT_LOGO_PATH;
  }

  if (/^https?:\/\//i.test(rawPath)) {
    return rawPath;
  }

  let normalizedPath = normalizeRelativePath(rawPath);
  const lowercasePath = normalizedPath.toLowerCase();
  const companyLogoMarkerIndex = lowercasePath.indexOf(COMPANY_LOGO_PATH_PREFIX);

  if (companyLogoMarkerIndex >= 0) {
    normalizedPath = normalizedPath.substring(companyLogoMarkerIndex);
  }

  if (normalizedPath.toLowerCase().startsWith(COMPANY_LOGO_PATH_PREFIX)) {
    const gatewayOrigin = getCompanyGatewayOrigin();
    return gatewayOrigin ? `${gatewayOrigin}${normalizedPath}` : normalizedPath;
  }

  return normalizedPath;
};

export const getDefaultLogoPath = () => DEFAULT_LOGO_PATH;
